import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f63e8af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item item-fund" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = { class: "price" }
const _hoisted_8 = { class: "meta" }
const _hoisted_9 = { class: "meta-title" }
const _hoisted_10 = { class: "avator" }
const _hoisted_11 = { style: {"margin-left":"5px"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_13 = { class: "desc" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "行业：", -1))
const _hoisted_15 = { class: "tag-item" }

import { ref, reactive, computed } from 'vue'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'ItemProjectFund',
  props: {
  data: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props
const route = useRoute();
const rate = ref(0)
const prjUrl = computed(() => {
  return '/fund/' + state.id
})
const isNewWindow = computed(()=>{
  return route.path.indexOf('ucenter')!=-1?'_blank':''
})
const state = reactive({ ...(props.data || {}) })
rate.value = Number(state.userStarLevel) || 0

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_rate = _resolveComponent("el-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: prjUrl.value,
      class: "poster",
      target: isNewWindow.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: state.coverImage
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to", "target"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: prjUrl.value,
              style: {"max-width":"380px","display":"inline-block"},
              target: isNewWindow.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(state.investIntent), 1)
              ]),
              _: 1
            }, 8, ["to", "target"]),
            _createElementVNode("div", null, [
              _createTextVNode(" 投资规模："),
              _createElementVNode("span", _hoisted_7, _toDisplayString(state.investScale) + "元", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_svg_icon, { icon: "icon_avator" }),
                _createElementVNode("span", null, _toDisplayString(state.userNickname), 1)
              ]),
              _createVNode(_component_el_rate, {
                modelValue: rate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rate).value = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(state.province) + _toDisplayString(state.city), 1)
            ]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(state.userIndustry), 1)
        ])
      ])
    ])
  ]))
}
}

})